import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setIsLoadingObjectTypes,
  setAndSortObjectTypes,
  selectCrmOrgsMap,
} from '../../components/pages/environments/environmentsReducer';
import { useCrmOrgsApiFacade } from '../../apis/facades/useCrmOrgsApiFacade';
import { telemetry } from '../../telemetry';

const useFetchCrmOrgObjectTypes = () => {
  const dispatch = useDispatch();
  const crmOrgsMap = useSelector(selectCrmOrgsMap);

  const { get_crmOrgsObjectTypes } = useCrmOrgsApiFacade();

  const handleIsLoadingObjects = useCallback(
    (crmOrgId: string) => {
      dispatch(setIsLoadingObjectTypes({ crmOrgId }));
    },
    [dispatch],
  );

  const fetchCrmOrgObjectTypes = useCallback(
    async ({ crmOrgId }: { crmOrgId: string }): Promise<{ error: boolean }> => {
      const isLoadingCrmOrgObjectTypes = crmOrgsMap[crmOrgId]?.loadingObjectTypes;
      //isLoadingCrmOrgObjectTypes is relevant only in case crmOrgId exist
      //in case of using "_crmOrgId", we check is being done on a parent function
      if (isLoadingCrmOrgObjectTypes && crmOrgId) {
        return {
          error: false,
        };
      }

      handleIsLoadingObjects(crmOrgId);

      try {
        const { objectTypes } = await get_crmOrgsObjectTypes({ orgId: crmOrgId });

        dispatch(
          setAndSortObjectTypes({
            objectTypes,
            crmOrgId,
          }),
        );

        return {
          error: false,
        };
      } catch (e) {
        telemetry.captureError(e);
        dispatch(setAndSortObjectTypes({ crmOrgId, objectTypes: [] })); //so it will not cause infinite loop
        return {
          error: true,
        };
      }
    },
    [crmOrgsMap, handleIsLoadingObjects, get_crmOrgsObjectTypes, dispatch],
  );

  return fetchCrmOrgObjectTypes;
};

export default useFetchCrmOrgObjectTypes;
